var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUpBtn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 16,
    viewBox: "0 0 28 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.651929 14.5304C1.03258 14.8977 1.54879 15.104 2.08703 15.104C2.62527 15.104 3.14148 14.8977 3.52213 14.5304L13.5699 4.83286L23.6176 14.5304C24.0004 14.8873 24.5132 15.0847 25.0454 15.0803C25.5776 15.0758 26.0867 14.8698 26.4631 14.5065C26.8394 14.1433 27.0529 13.6519 27.0575 13.1383C27.0622 12.6246 26.8576 12.1297 26.4878 11.7602L15.005 0.677602C14.6243 0.310327 14.1081 0.104004 13.5699 0.104004C13.0316 0.104004 12.5154 0.310327 12.1348 0.677602L0.651929 11.7602C0.271391 12.1276 0.0576172 12.6258 0.0576172 13.1453C0.0576172 13.6648 0.271391 14.163 0.651929 14.5304Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpBtn);
export default __webpack_public_path__ + "static/media/up_btn.eaa15f63332cfb624979ea339aed1500.svg";
export { ForwardRef as ReactComponent };